module.exports = __webpack_public_path__ + "static/media/Icon_HVAC.273aaa08.png";